import { useMemo } from "react";
import { useStore as useGameStore } from "../store";
import { mergeCloseTimeSpanEvents } from "../functions";
import { MergedGpEventResponse } from "../types";

export const useAttachedEvents = (eventIds: number[] | null | undefined): MergedGpEventResponse[] => {
	const allEvents = useGameStore((state) => state.eventFilter.events);

	return useMemo(() => {
		if (!eventIds?.length) return [];

		const eventIdSet = new Set(eventIds);
		return mergeCloseTimeSpanEvents(allEvents.filter((event) => eventIdSet.has(event.id)));
	}, [allEvents, eventIds]);
};
